import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { SwModalframeComponent } from '../../../basic-components/sw-modal-frame/sw-modal-frame.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { BdpService } from 'src/app/areas/bdp/bdp.service';
import { environment } from 'src/environments/environment';
import { SwMenuService } from 'src/app/librarys/serves/sw-menu.service';
import { SwMassageConfirmComponent } from '../../../basic-components/sw-massage-confirm/sw-massage-confirm.component';

@Component({
  selector: 'app-sw-quick-menus-box',
  templateUrl: './sw-quick-menus-box.component.html',
  styleUrls: ['./sw-quick-menus-box.component.css']
})
export class SwQuickMenusBoxComponent implements OnInit {

  @Input() param: any;

  @Output() callback = new EventEmitter(); //抛出事件

  @ViewChild("modal") modal: SwModalframeComponent

  @ViewChild("selectAllInput") selectAllInput : ElementRef

  //隐藏左边栏目
  showLeft: boolean = true; 

  //左边树的数据
  treeList: any = [] 
  treeList2: any = [] 

  //选中菜单数据
  checkdModel: any = {}  

  //全选按钮是否选中，默认不选中
  selectAllMenus:boolean = false  

  //一级模块信息
  areas: any = [];

  // 对应模块的菜单信息
  menus: any = [];

  //查询到的已经勾选的菜单
  checkedList: any = []

  //树组件禁用节点（不设计子节点）
  readonlySelfId:any[] = []

  //初始化时已经选中的菜单
  initSelectedMenus:any[] = []

  //最新的已经选中的菜单
  selectedMenus:any[] = []
  
  /**
   * 提示框对象
   * @ignore
   */
  @ViewChild("trim") trim: SwMassageConfirmComponent

  constructor(
    private systemId: SystemIdService,
    private User: GetUserModelService,
    private http: SwHttpClientService,
    private box: SwMassageBoxService,
    private service: BdpService,
    private menu: SwMenuService, //请求菜单服务
  ) { }

  ngOnInit() {
    //获取已经选中的菜单
    this.selectedMenus = JSON.parse(JSON.stringify(this.param.selectedMenus))
    this.initSelectedMenus = JSON.parse(JSON.stringify(this.param.selectedMenus))
    
    this.selectedMenus.forEach((item)=>{
      this.checkdModel[item.functionId] = true
    })

    //获取所有模块和菜单信息
    this.areas = this.menu.getAreasVal(); //所有一级菜单信息
    this.menu.areasUpdated.subscribe(val => {
      this.areas = this.menu.getAreasVal(); //所有一级菜单信息
    })

    //获取到一级菜单之后，处理成树组件需要的数据格式
    this.handleAreas(this.areas)

    this.treeList = JSON.parse(JSON.stringify(this.treeList2))
    //获取选中数据
    // this.selectQuickMenus() 
  }

  ngAfterViewInit(): void { 
  }
  
  /**
   * 点击左侧树组件时，看右侧菜单是否有父级菜单需要回显勾选的
   */
  checkFather(){
    this.menus.forEach(m => {
      if(m.children && m.children.length){
        let checkNum = m.children.filter(v=>this.checkdModel[v.functionId])
        if(checkNum.length == m.children.length){
          //如果该父级菜单的所有子级都选中了，那么这个父级也要选中
          if(!this.checkdModel[m.functionId]){
            this.checkdModel[m.functionId] = true
          }
        }
      }
    });
  }

  /**
   * 将获取到的一级菜单处理
   * @param event 
   */
  handleAreas(areas){
    for (let i = 0; i < areas.length; i++) {
      this.treeList2.push(areas[i])
      if(areas[i]['children'] && areas[i]['children']['length'] && areas[i]['css'] == '1'){
        //如果存在子级，就递归,且该节点不能点击,类似于数据中心
        this.readonlySelfId.push(areas[i]['functionId'])
        this.handleAreas(areas[i]['children'])
      } 
    }
  }

  /**
   * 用递归的方法将被隐藏的菜单全部删掉
   * @param event 
   */
  filterIsHidden(list:any[]){
    for (let i = list.length-1; i >= 0; i--) {
      //菜单隐藏或无子菜单又不能跳转
      if(list[i]["isHidden"] || (!list[i]['children'] && !list[i]['uri']) || (list[i]['children'] && !list[i]['children']['length'] && !list[i]['uri'])){
        //如果该菜单被隐藏，就要删除该菜单, splice方法是数组删除的方法，会改变原数组
        list.splice(i,1)
      } else if(list[i]["children"] && list[i]["children"]["length"] > 0){
        //如果没有隐藏，就看它的子菜单
        this.filterIsHidden(list[i]["children"])
      }
    }
  }


  /**
   * 树形选中数据
   * @param event 
   */
  onVoted(event) {
    //全选取消
    this.selectAllInput.nativeElement.checked = false
    //获取当前用户信息
    let user = this.User.getUser();
    //请求加载数据
    this.http.Post(environment.seekerWebAPI + "function/queryFunctionsByUserId?parentId=" + event.key +
      "&systemId=" + this.systemId.getSystemId() + "&type=1" + "&userId=" + user["userId"]
      , {}).subscribe(
        data => {
          if (data["code"] === 200) {
            this.menus = data["data"]
            if(this.menus['length']){
              //如果查得到下级
              //将隐藏的菜单,或没有子菜单且没有跳转路径的菜单 全都删除
              this.filterIsHidden(this.menus)

              //将回显的勾选之后，还要看是否有父级菜单（子级菜单全部回显了，但是父级没有勾选的情况）需要勾选
              this.checkFather()
            } else {
              //查不到下级，比如 工作门户或者是数据可视化这种，uri 值存在，就把该菜单作为自己的下级
              this.menus = [event.data]
            }
          }
        }
      )
  }

  /**
   * 每次勾选或取消勾选菜单，此时勾选结果已结束，都要判断全选反选按钮要不要勾选
   * type: 指定是点击的span还是 input,为2是点击的是span,此时需要手动修改该菜单的勾选状态，为1时是input，不需要手动修改勾选状态
   * @param event
   */
  changeMenu(event,menu1,menu2,type){
    if(menu2){
      if(type == 2){
        this.checkdModel[menu2.functionId] = !this.checkdModel[menu2.functionId]
      }
      //如果点击的是二级菜单，勾选的话，就要看对应的一级菜单是否全选
      let childIds = menu1.children.map(v=>v.functionId)  //找到对应一级菜单下的所有二级菜单id
      let checked = true  //假设一级菜单勾选了
      childIds.forEach(id => {
        if(!this.checkdModel[id]){
          checked = false
        }
      });
      //修改对应一级菜单是否勾选
      this.checkdModel[menu1.functionId] = checked
      //点击的是二级菜单，就找到 this.selectedMenus 中是否有，勾选了加加进去，取消勾选就从中删除
      let i = this.selectedMenus.findIndex(v=>v.functionId == menu2.functionId)
      if(this.checkdModel[menu2.functionId]){
        //勾选了二级菜单
        if(i >= 0){  //该二级菜单在最上面已经存在，不做处理
        }else{
          this.selectedMenus.push(menu2)  //该二级菜单在最上面不存在，就加入
        }
      } else {
        //取消勾选二级菜单
        if(i >= 0){  //该二级菜单在最上面已经存在，从中删除
          this.selectedMenus.splice(i,1)
        }else{  //该二级菜单在最上面不存在，就不做处理
        }
      }
    } else {
      if(type == 2){
        this.checkdModel[menu1.functionId] = !this.checkdModel[menu1.functionId]
      }
      //点击的是一级菜单,如果有子级的话，就把其所有子级勾选状态都修改一致
      if(menu1.children && menu1.children.length){
        menu1.children.forEach(child => {
          this.checkdModel[child.functionId] = this.checkdModel[menu1.functionId]  //将它的所有二级勾选状态全都改为与自身一样
          let i = this.selectedMenus.findIndex(v=>v.functionId == child.functionId)
          if(this.checkdModel[child.functionId]){
            //勾选了二级菜单
            if(i >= 0){  //该二级菜单在最上面已经存在，不做处理
            }else{
              this.selectedMenus.push(child)  //该二级菜单在最上面不存在，就加入
            }
          } else {
            //取消勾选二级菜单
            if(i >= 0){  //该二级菜单在最上面已经存在，从中删除
              this.selectedMenus.splice(i,1)
            }else{  //该二级菜单在最上面不存在，就不做处理
            }
          }
        });

      } else {
        //点击的一级菜单没有下级
        let i = this.selectedMenus.findIndex(v=>v.functionId == menu1.functionId)
        if(this.checkdModel[menu1.functionId]){
          //勾选了一级菜单
          if(i >= 0){  //该一级菜单在最上面已经存在，不做处理
          }else{
            this.selectedMenus.push(menu1)  //该一级菜单在最上面不存在，就加入
          }
        } else {
          //取消勾选一级菜单
          if(i >= 0){  //该一级菜单在最上面已经存在，从中删除
            this.selectedMenus.splice(i,1)
          }else{  //该一级菜单在最上面不存在，就不做处理
          }
        }
      }
    }
    //每次勾选菜单，都要判断全选反选按钮要不要勾选，先默认勾选
    this.selectAllMenus = true
    //判断该模块下的所有有效菜单是否全部勾选
    this.isAllSelected(this.menus)
    //手动修改全选按钮的勾选情况
    this.selectAllInput.nativeElement.checked = this.selectAllMenus
  }

  /**
   * 判断全选是否勾选
   * @param menus
   */
  isAllSelected(menus){
    for (let i = 0; i < menus.length; i++) {
      if((!menus[i]["children"] || menus[i]["children"]["length"] <= 0) && menus[i]["uri"]){
        //如果该菜单没有选中就不勾选全选按钮
        let key = menus[i]['functionId']
        if(!this.checkdModel[key]){
          this.selectAllMenus = false
          return
        }
      } else if(menus[i]["children"] && menus[i]["children"]["length"] > 0){
        if(!this.selectAllMenus){
          //如果已经确定不是全选了，就直接 return
          return
        } else {
          //如果存在下级菜单，就递归
          this.isAllSelected(menus[i]["children"])
        }
      }
      if(!this.selectAllMenus){
        return
      }
    }
  }

  /**
   * 回显已经选中的菜单
   */
  /* selectQuickMenus() {
    this.http.Post(environment.seekerWebAPI + "shortcut/queryByFk", {systemId:this.systemId.getSystemId,userId:this.User.getUser()["userId"]}).subscribe(data => {
      if (data["code"] == 200) {
        setTimeout(() => {
          this.checkedList = data["data"]
          data["data"].forEach(item => {
            this.checkdModel[item.functionId] = true
          })
          console.log('this.checkdModel',this.checkdModel);
          
        }, 100)
      }
    })
  } */

  /**
   * 点击全选反选按钮
   * @param event 
   */
  selectAll(event){
    //递归将所有菜单选中或取消选中
     this.selectOrCancelMenus(this.menus,event.target.checked)
  }

  /**
   * 递归选中或取消选中该模块下的所有菜单
   * @param menus 
   */
  selectOrCancelMenus(menus,isSelect){
    for (let i = 0; i < menus.length; i++) {
      if((!menus[i]["children"] || menus[i]["children"]["length"] <= 0) && menus[i]["uri"]){
        //如果该菜单没有下级菜单,且存在跳转路径，就选中
        let key = menus[i]['functionId']
        this.checkdModel[key] = isSelect 
        let index = this.selectedMenus.findIndex(v=>v.functionId == key)
        if(this.checkdModel[key]){
          //勾选了一级菜单
          if(index >= 0){  //该一级菜单在最上面已经存在，不做处理
          }else{
            this.selectedMenus.push(menus[i])  //该一级菜单在最上面不存在，就加入
          }
        } else {
          //取消勾选一级菜单
          if(index >= 0){  //该一级菜单在最上面已经存在，从中删除
            this.selectedMenus.splice(index,1)
          }else{  //该一级菜单在最上面不存在，就不做处理
          }
        }
      } else if(menus[i]["children"] && menus[i]["children"]["length"] > 0){
        //如果存在下级菜单，就递归
        //这个菜单还是要一起勾选或取消勾选，样式要一致
        this.checkdModel[menus[i]['functionId']] = isSelect 
        this.selectOrCancelMenus(menus[i]["children"],isSelect)
      }
    }
  }

  /**
   * 点击最上方选中菜单的删除按钮
   */
  delete(selected,i){
    //先将下面的勾选取消，有父级的话，父级也要取消勾选
    this.checkdModel[selected['functionId']] = false
    if(selected['parentId']){
      this.checkdModel[selected['parentId']] = false
    }
    this.selectedMenus.splice(i,1)  //最上方的删除
  }

  /**
   * 删除所有已经选中的菜单
   */
  deleteAll(){
    this.trim.openCLick("确认清空所有选中菜单？", (data) => {
      if(data){
        this.checkdModel = {}
        this.selectedMenus = []
        //全选取消
        this.selectAllInput.nativeElement.checked = false
      }
    })
  }

  /**
   * 保存数据列表
   */
  save() {
    let addList = []
    let delList = []
      //1.初始化中存在的，最新选中没有的，就是删除的
      this.initSelectedMenus.forEach(item=>{
        let i = this.selectedMenus.filter(x=>x.functionId == item.functionId)
        if(i.length==0){
          delList.push(item.shortcutId)  //删除的时候，不是用菜单id(functionId)删除的，而是用 快捷菜单id()
        }
      })
      let userId = this.User.getUser()["userId"];
      //2.最新选中中存在的，初始化中没有的，就是新增的
      this.selectedMenus.forEach(item=>{
        let i = this.initSelectedMenus.filter(x=>x.functionId == item.functionId)
        if(i.length==0){
          addList.push({functionId:item.functionId,userId:userId,systemId:this.systemId.getSystemId()})
        }
      })
      let params = {
      "param": { Ids: delList },
      "list": addList
      }
      this.http.Post(environment.seekerWebAPI + "shortcut/saveOrDelete", params).subscribe(data => {
        if (data["code"] == 200) {
          this.box.success("设置成功")
          this.modal.toggle()
          this.callback.emit(true)
        } else {
          this.box.danger(data["msg"])
        }
      })

    
  }
}
